var feed = new Instafeed({
		get: 'user',
		userId: 1550625473,
		accessToken: '1550625473.1677ed0.2b14869c112f458ba189f40bb0c9c12e',
		target: 'instagram',
		resolution: 'standard_resolution',
		limit: 16,
  		template: '<div class="three"><div class="photo-card"><img class="img-responsive photo-thumb" src="{{image}}" alt="{{caption}}"><div class="caption">{{model.created_time}}</div></div></div>',
  		after: function() {
			var el = document.getElementById('instagram');
			if (el.classList)
				el.classList.add('show');
			else
				el.className += ' ' + 'show';
		},

	filter: function(image) {

		var date = new Date(image.created_time*1000);

		m = date.getMonth();
		d = date.getDate();
		y = date.getFullYear();

		var month_names = new Array ( );
		month_names[month_names.length] = "January";
		month_names[month_names.length] = "February";
		month_names[month_names.length] = "March";
		month_names[month_names.length] = "April";
		month_names[month_names.length] = "May";
		month_names[month_names.length] = "June";
		month_names[month_names.length] = "July";
		month_names[month_names.length] = "August";
		month_names[month_names.length] = "September";
		month_names[month_names.length] = "October";
		month_names[month_names.length] = "November";
		month_names[month_names.length] = "December";

		var thetime = month_names[m] + ' ' + d + ', ' + y;

		image.created_time = thetime;

		return true;
	}

});

feed.run();
